import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';

import { RegionService } from '../../services/region.service';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'confirm-finish-page',
  templateUrl: 'confirm-finish.html',
})
export class ConfirmFinishPage {
  constructor(private trackingService: TrackingService, public regionService: RegionService, public viewCtrl: ViewController) {}
  finish() {
    this.trackingService.resetTrackingValues();
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/confirm-finish/confirm-finish.ts